var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"swiper-box"},[_c('div',{staticClass:"swiper-contain"},[_c('div',{staticClass:"swiper-wrapper"},_vm._l((_vm.spuImgs),function(spuImg,spuIndex){return _c('div',{key:spuIndex,staticClass:"swiper-slide"},[_c('img',{attrs:{"src":spuImg,"alt":"banner"}})])}),0),_vm._v(" "),_c('div',{staticClass:"swiper-pagination"})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cad30de0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/swiper.vue
// module id = null
// module chunks = 